/* jshint esnext:true */

import * as React from 'react';
import ReactDOM from 'react-dom';
import {MessageForm} from 'mk/forms/MessageForm';
import fakeContext from 'mk/common/fluxible/fakeContext';

/*
data = {
    className: string
    placeholder: string, default: 'WRITE_NEW_MESSAGE'
    buttonValue: string, default: 'BZ2_SUBMIT_MESSAGE'

    action: string

    additionalElements: oneOfType(element, array)
    additionalFormFields: oneOfType(element, array)

    onClean: func
    onSubmit: func
    onError: func
    onSubmitSuccess: func
    onSubmitFailure: func

    photos: bool, default: false
    stickers: bool, default: false
    snippets: bool, default: false
    emojis: bool, default: false
    visibility: bool, default: false

    autofocus: bool, default: false
    initialMessage: string
    messageRequired: bool, default: true
    messageLabel: string

    photoType: string
    previewPhotoSize: string
    multiplePhotos: bool, default: true
    initialPhotos: array, default: [] // array of photo tokens

    defaultVisibility: number, default: 1
}
*/

export default function renderMessageForm(data, container) {
    data.context = fakeContext();
    return ReactDOM.render(React.createElement(MessageForm, data, null), container);
}
